// extracted by mini-css-extract-plugin
module.exports = {"container":"usageIcon_container__dUlLH","label":"usageIcon_label__1gLq0"};